import { gql } from '@apollo/client';

export const ALL_PORTFOLIOS_FOR_SELECT_INPUT = gql`
  query GetPortfolios($input: PortfolioFilterInput!) {
    portfolios: getPortfolios(input: $input) {
      id
      name
    }
  }
`;
